module.exports = __webpack_public_path__ + "b31167693b08d4c08b7252f5385101da.MP3";